import React from 'react';
import { LineTab as LineTabNew } from './LineTab';
import { convertOldLineTabProps } from './converter.old';
import type { OldLineTabComponentProps, OldLineTabProps } from './converter.old';

export type LineTabProps = OldLineTabProps;
export type LineTabComponentProps = OldLineTabComponentProps;

export const LineTab: React.FC<LineTabComponentProps> = (props) => <LineTabNew {...convertOldLineTabProps(props)} />;
